export const AUTH_LOGGED_IN_TOAST_TRIGGER = "auth-signed-in";
/**
 * Used by the onboarding flow to show the explore view after login redirect. Also used to open the explore view with a search query from an external source.
 */
export const TOOLBAR_SHOW_EXPLORE = "explore";

/**
 * Used by the onboarding flow to hide the "Learn background" and allow users to view projects
 */
export const ONBOARDING_HIDE_BG = "o-hbg";

/**
 * Used to save the last viewed project ID to local storage
 */
export const LAST_VIEWED_PROJECT = "last-viewed-project";
